import React, {  useEffect } from 'react';
import { Table, Input, Select } from 'antd';
import "./Table.css"
import moment from 'moment';

function DataTable({ data, setActiveCasetData, toggleAddReadingModal }: any) {
    const columns: any= [
        { 
          title: '#', 
          dataIndex: 'index', 
          key: 'index',
          render: (text: any, record: any, index: number) => index + 1,
        },
        {
          title: 'Patient Phone', 
          dataIndex: 'patient_phone', 
          key: 'patient_phone',
          render: (phone: any) => (phone ? phone : '--'),  
        },
        {
            title: 'Date Subscribed',
            dataIndex: 'createdAt',
            key: 'createdAt',
            // sorter: (a: any, b: any) => a.name.localeCompare(b.name),
            render: (createdAt: any) => (createdAt ? moment.unix(createdAt.seconds).format('YYYY-MM-DD HH:mm:ss') : '--'), 
          },
          {
            title: 'End Date',
            dataIndex: 'end_date',
            key: 'end_date',
            // sorter: (a: any, b: any) => a.name.localeCompare(b.name),
            render: (end_date: any) => (end_date ? moment.unix(end_date.seconds).format('YYYY-MM-DD HH:mm:ss') : '--'), 
          },
          {
            title: 'Case Codes',
            dataIndex: 'codes',
            key: 'codes',
            render: (codes: any) => codes.map((code: any) => `${code} `)
          },
          {
            title: 'Status',
            dataIndex: 'isActive',
            key: 'isActive',
            render: (isActive: any) => (isActive ? 'Active' : 'Not Active')
          },
          {
            title: 'Duration',
            dataIndex: 'plan_length',
            key: 'plan_length',
            render: (plan_length: any) => `${plan_length} Months`, 
          },
      ];
  
      

    return (
        <Table
            columns={columns}
            // expandable={{ expandedRowRender, defaultExpandedRowKeys: ['0'] }}
            dataSource={data.map((item: any, index: any) => ({ ...item, index: index + 1 }))}
      />
    );
}

export default DataTable;